import { Injectable } from "@angular/core";
import { Select, Store } from "@ngxs/store";
import { combineLatest, Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ErrorType } from "../../model/face.model";
import { FaceService } from "../../services/async/connectors/face.service";
import { ImageService } from "../../services/face-processor.service";
import { setIdImageLoad } from "../../store/actions/face.action";
import { idTimeOut, requestIdFaceDetection, setDefaultId } from "../../store/actions/id.action";
import { GlobalState } from "../../store/state/global.state";
import { IdState } from "../../store/state/id.state";
import { Sandbox } from "../sandbox";

@Injectable()
export class IdSandbox extends Sandbox {

    @Select(IdState.getIdImage) idImage: Observable<string>;
    @Select(IdState.isLoading) isLoading: Observable<boolean>;
    @Select(IdState.isLoaded) isLoaded: Observable<boolean>;
    @Select(IdState.isError) isError: Observable<boolean>;
    @Select(IdState.isIdImageLoading) isImageLoading: Observable<boolean>;
    @Select(IdState.isQualityError) isQualityError: Observable<ErrorType>;
    @Select(IdState.isNoFaceDetectedError) noFaceError: Observable<ErrorType>;
    @Select(IdState.isTooManyFacesDetectedError) tooManyFacesError: Observable<ErrorType>;
    @Select(IdState.isMediatypeError) isdMediaTypeError: Observable<ErrorType>;
    @Select(GlobalState.getToken) token: Observable<string>;
    @Select(GlobalState.getFaceUrl) faceUrl: Observable<string>;

    constructor(private faceService: FaceService, private imageService: ImageService, private store: Store) {
        super(store);
    }

    public maxSize = 1000000; //max 1Mo;

    uploadIdDocument(e) {
        this.store.dispatch(new setDefaultId());
        combineLatest([this.token, this.faceUrl]).subscribe(
            ([token, faceUrl]) => {
                if (e.target.files[0].size > this.maxSize) {
                    this.imageService.resizeImage(e.target.files[0]).then(
                        (image) => {
                            this.store.dispatch(
                                new requestIdFaceDetection({
                                    idImage: image,
                                    token: token,
                                    url: faceUrl
                                })
                            );
                        }
                    );
                }
                else {
                    this.store.dispatch(
                        new requestIdFaceDetection({
                            idImage: e.target.files[0],
                            token: token,
                            url: faceUrl
                        })
                    );
                }
            }
        );
    }

    public getIdImage(): Observable<any> {
        return this.idImage.pipe(
            map((res) => {
                return 'data:image/png;base64,' + res;
            })
        )
    }

    onIdTimeOut() {
        this.store.dispatch(new idTimeOut(true));
    }

    public clearIdFile(): void {
        this.store.dispatch(new setIdImageLoad(false));
    }


}